<template>
  <div class="slideWrap">
    <!-- menuList: {{ menuList }} -->
    <!-- :unique-opened="true" -->
    <!-- v-if="activeIndex === item.parentAuthId.toString() && item.childList" -->
    <el-menu
      :default-active="onRoutes"
      :default-openeds="openeds"
      class="el-menu-vertical-demo"
    >
      <template>
        <template v-for="(item, index) in menuList">
          <el-submenu
            v-if="activeIndex == item.parentAuthId.toString() && item.childList"
            :key="'first' + index"
            class="submenu-s"
            :index="item.authId.toString()"
          >
            <template>
              <template
                slot="title"
                :style="collapse ? 'z-index:1000' : 'z-index:10'"
              >
                {{ item.authName }}
              </template>
              <template>
                <template v-for="(subItem, subInx) in item.childList">
                  <!-- {{ subItem.authCode }} -->
                  <template v-if="!subItem.authCode.startsWith('http')">
                    <el-menu-item
                      :key="'second' + subInx"
                      :index="subItem.authCode"
                      @click="handleItem(subItem)"
                    >
                      <span>{{ subItem.authName }}</span>
                      <div v-if="subItem.authName === '石化商城订单'" class="num-box">{{petrolMallOrderNum}}</div>
                        <div v-if="subItem.authName === '石化采购意向单'" class="num-box">{{countUnLinkedNum}}</div>
                      <eui-icon v-if="subItem.businessType && subItem.businessType === 1" icon="eicon-zhongguoshihua"
                                  style="margin-left: 4px;"/>
                    </el-menu-item>
                  </template>
                  <template v-else>
                    <el-menu-item
                      :key="'second' + subInx"
                      :index="subItem.authCode"
                      @click="handleItemHttp(subItem)"
                    >
                      <span>{{ subItem.authName }}</span>
                        <eui-icon v-if="subItem.businessType && subItem.businessType === 1" icon="eicon-zhongguoshihua"
                                  style="margin-left: 4px"/>
                    </el-menu-item>
                  </template>
                </template>
              </template>
            </template>
          </el-submenu>
          <!-- 没有三级菜单 -->
          <el-menu-item
            v-if="!item.childList"
            :key="'first' + index"
            class="none_childList"
            :index="item.authId.toString()"
          >
            <div
              slot="title"
              class="none_childList_name"
              style="padding-left: 5px"
              @click="handleParentItems(item)"
            >
              {{ item.authName }}
            </div>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
    <!-- <div class='rightArrow' @click='slide'> > </div> -->
    <!-- :key="'first' + index" :index="item.authId.toString()"> -->
    <!-- :key="item.authId.toString()" :index="item.authId.toString()"> -->
    <!-- -->
  </div>
</template>

<script>
import bus from './bus';
import store from "../../modules/projectA/store";
import api from '@/modules/projectA/api/order';
import EuiBtn from "epec-ui/src/package/eui-btn/index";

export default {
  name: 'SiderRight',
  components: {EuiBtn},
  props: {
    // activeIndex: {
    //   required: true,
    //   type: String,
    // },
    // menuList: {
    // 	type: Array,
    // }
  },
  data() {
    return {
      countUnLinkedNum: 0,
      petrolMallOrderNum: 0,
      testArr: [
        {
          parentAuthId: 12234,
          authId: 12251,
          authName: '询价管理',
          authCode: '',
          sort: 10,
          flag: false,
          childList: [
            {
              parentAuthId: 12251,
              authId: 12253,
              authName: '发布询价单',
              authCode: '/enquiryManage/enquiryIss',
              sort: 300,
              flag: false,
            },
            {
              parentAuthId: 12251,
              authId: 12444,
              authName: '询价单管理',
              authCode: '/enquiryManage/enquiry',
              sort: 200,
              flag: false,
            },
            {
              parentAuthId: 12251,
              authId: 12255,
              authName: '物流发货询比价',
              authCode: 'https://ewuliu.epec.com/',
              sort: 100,
              flag: false,
            },
          ],
        },
      ],
      slideStatus: true,
      // activeIndex: localStorage.getItem('firstIndex') ? localStorage.getItem('firstIndex') : '10136',
      menuList: [],
      activeIndex: '',
      openeds: [],
      collapse: false,
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path;
    },
  },
  mounted() {
    bus.$on('menuList', (res) => {
      setTimeout(() => {
        if (res && res.length > 0) {
          this.menuList = [...res];
          if (this.menuList) {
            for (let i = 0; i < this.menuList.length; i++) {
              this.openeds.push(String(this.menuList[i].authId));
              this.openeds = [...new Set(this.openeds)];
            }
          }
        }
      }, 0);
    });
    bus.$on('activeIndex', (res) => {
      this.activeIndex = res;
      console.log(this.activeIndex, 'this.activeIndex right');
    });
    bus.$on('collapse', (res) => {
      this.collapse = res;
      console.log(this.collapse, 'this.collapse right');
    });
    //待关联石化采购意向单 数量
    this.countUnLinked();
    //石化商城订单-待关联 数量
    this.petrolMallOrderUnLinkedNum();
  },
  methods: {
    async petrolMallOrderUnLinkedNum() {
      const res = await api.petrolMallOrderUnLinkedNum();
      if (res.code === '200') {
        const {data = 0} = res;
        if (data && Number(data) > 99) {
          this.petrolMallOrderNum = '99+'
        } else {
          this.petrolMallOrderNum = data || 0;
        }
      }
    },
    //待关联石化采购意向单 数量
    async countUnLinked() {
      const res = await api.countUnLinked();
      if (res.code === '200') {
        if (res.data && Number(res.data) > 99) {
          this.countUnLinkedNum = '99+'
        } else {
          this.countUnLinkedNum = res.data || 0;
        }
      }
    },
    async handleItem(subItem) {
      this.setPvUv(subItem);
      const arr = [
        '资质信息',
        '管理信息',
        '供应服务能力信息',
        '股权占比',
        '重大事件报备',
        '最差评价',
        '石化销售产品目录',
      ];
      for (const i of arr) {
        if (subItem.authName === i) {
          this.$message('建议在 ie 浏览器下浏览此页面');
        }
      }
      let times = new Date();
      times = times.getTime();
      this.$router.push({ path: subItem.authCode, query: { t: times } });
    },
    handleParentItems(item) {
      if (item.authCode.startsWith('http')) {
        window.open(item.authCode);
      }
    },
    handleItemHttp(subItem) {
      if (subItem.authCode && subItem.authCode.startsWith('http')) {
        this.setPvUv(subItem);
        let url = subItem.authCode;
        if (process.env.environment === 'production') {
          url = url
            .replace(/http:/g, 'https:')
            .replace(/uat-mall.epec.com/g, 'mall.epec.com')
            .replace(/uat-member.epec.com/g, 'member.epec.com');
        }
        window.open(url);
      }
    },
  // 埋点
    setPvUv(to){
      const params = {
        code: 302,
        fullPath: to.authCode,
        name: to.authName,
      };
      store.dispatch('setPVUV', params);
    }
  },
};
</script>

<style lang="scss" scoped>
.num-box {
  display: inline-block;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  color: #fff;
  background-color: #f56c6c;
  border-radius: 10px;
  margin-left: 4px;
  font-size: 10px;
}
::-webkit-scrollbar {
  width: 0 !important;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

::v-deep .el-submenu__title i {
  color: #666666;
  font-weight: bold;
}

.slideWrap {
  // width: 100px;
  width: 160px;
  // height: 100vh;
  background-color: rgb(248, 248, 248);
  position: relative;
  display: inline-block;
  line-height: 1;

  .rightArrow {
    position: absolute;
    top: 50%;
    right: 0;
    width: 40px;
    height: 0px;
    background-color: #e0c46c;
    color: #fff;
    transform: perspective(0.2em) rotateX(5deg);
    // transform:rotateX(5deg) rotate(90deg);
    transform-origin: bottom;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.slideOpen {
  width: 0px;
}

.el-menu-vertical-demo {
  width: 160px;
  // height: calc(100% - -6px);
  // height: calc(100vh - 64px);
  font-family: Source Han Sans CN;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: #666666;
  overflow: hidden;
  overflow-y: auto;
  background: #f8f8f8;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  height: 100%;

  ::v-deep .el-menu-item {
    color: rgb(102, 102, 102) !important;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background: #f8f8f8;
    font-family: Source Han Sans CN;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #666666;
    padding-left: 0px !important;
    height: 45px;
    line-height: 45px;

    > span {
      width: 100%;
      height: 14px;
      border-left: 4px solid #f8f8f8;
      padding-left: 5px;
    }
  }

  ::v-deep .is-active {
    > span {
      color: #2587ff;
      width: 100%;
      height: 14px;
      border-left: 4px solid #2587ff;
      padding-left: 5px;
    }
  }

  ::v-deep .el-submenu__title {
    height: 50px;
    line-height: 50px;
    padding-left: 5px !important;
    font-family: Source Han Sans CN;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    color: #333333;

    @if collapse==true {
      z-index: 1000;
    } @else {
      z-index: 10;
    }
  }

  .el-menu-item:hover {
    color: #2587ff !important;
  }
}

.none_childList {
  height: 50px !important;
  background: #fff;
}
.none_childList:hover {
  background: #e9f3ff;
}
.none_childList_name {
  height: 100%;
  display: flex;
  align-items: center;
  color: #333;
  font-weight: bolder;
}
:v-deep .el-submenu .el-menu-item {
  height: 45px;
  line-height: 45px;
}
</style>
